import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { lazy, Suspense, useMemo } from 'react';
import { Skeleton } from '../Skeleton';
import { GetLottiePlayerTID, importLottiePlayerInner } from './LottiePlayer.utils';
const LottiePlayerLazy = /*#__PURE__*/ lazy(importLottiePlayerInner);
export function LottiePlayer(_0) {
    let { width, height, className, style, testId } = _0, rest = _object_without_properties(_0, [
        "width",
        "height",
        "className",
        "style",
        "testId"
    ]);
    const { LottiePlayerTID } = useMemo(()=>GetLottiePlayerTID(testId), [
        testId
    ]);
    const fallback = useMemo(()=>/*#__PURE__*/ _jsx(Skeleton, {
            width: width,
            height: height,
            className: className,
            style: style,
            testId: LottiePlayerTID.Skeleton()
        }), [
        width,
        height,
        className,
        style,
        LottiePlayerTID
    ]);
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: fallback,
        children: /*#__PURE__*/ _jsx(LottiePlayerLazy, _object_spread({
            width: width,
            height: height,
            className: className,
            style: style,
            testId: testId
        }, rest))
    });
}
